import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { Button } from '../ui/button';

/** Barre de navigation commune aux pages services SEO. */
const SeoNav = () => (
  <nav className="bg-white shadow-sm sticky top-0 z-50" data-testid="seo-nav">
    <div className="max-w-7xl mx-auto px-4 py-3 md:py-4 flex items-center justify-between flex-wrap gap-4">
      <Link to="/" className="flex items-center" data-testid="seo-nav-logo">
        <img
          src="https://customer-assets.emergentagent.com/job_fix-phone-fast-1/artifacts/wscem8ro_ChatGPT%20Image%2024%20f%C3%A9vr.%202026%2C%2022_17_46.png"
          alt="Logo Suro Phone - Réparation smartphone Saint-Chamond"
          className="h-10 md:h-12 w-auto" />
      </Link>

      <div className="hidden md:flex items-center gap-8">
        <Link to="/" className="text-gray-600 hover:text-gray-900 transition-colors">Accueil</Link>
        <Link to="/zones-intervention" className="text-gray-600 hover:text-gray-900 transition-colors">Zones d'intervention</Link>
        <Link to="/blog" className="text-gray-600 hover:text-gray-900 transition-colors">Blog</Link>
      </div>

      <div className="flex items-center gap-4">
        <a href="tel:0773601521" className="flex items-center gap-2 text-gray-700 hover:text-gray-900 transition-colors">
          <Phone className="w-4 h-4" />
          <span className="font-medium">07.73.60.15.21</span>
        </a>
        <Link to="/rendez-vous" className="hidden sm:block">
          <Button className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition-colors">
            Prendre RDV
          </Button>
        </Link>
      </div>
    </div>
  </nav>
);

export default SeoNav;
